export const initialState = [
    {
        "id" : Math.random().toString(36).substring(6),
        "key": "segment_1",
        "segmentLabel": "Segment 1",
        "segmentFields": {
            "id": "segment1",
            "label": "Segment 1",
            "visible": true,
            "disable": false,
            "selectedIconUrl": "",
            "unSelectedIconUrl": ""
        }
    },
    {
        "id" : Math.random().toString(36).substring(6),
        "key": "segment_2",
        "segmentLabel": "Segment 2",
        "segmentFields": {
            "id": "segment2",
            "label": "Segment 2",
            "visible": true,
            "disable": false,
            "selectedIconUrl": "",
            "unSelectedIconUrl": ""
        }
    },
    {
        "id" : Math.random().toString(36).substring(6),
        "key": "segment_3",
        "segmentLabel": "Segment 3",
        "segmentFields": {
            "id": "segment3",
            "label": "Segment 3",
            "visible": true,
            "disable": false,
            "selectedIconUrl": "",
            "unSelectedIconUrl": ""
        }
    }
]